import { messaging } from './firebaseConfig';
import { getToken } from 'firebase/messaging';

const requestForToken = async () => {
    try {
        // const permission = Notification.permission;
        // if (permission === 'denied') {
        //     console.error('Notification permission has been blocked. Please enable notifications in your browser settings.');
        //     alert('Notifications are blocked. Please enable them in your browser settings to receive updates.');
        //     return;
        // }
        // if (permission !== 'granted') {
        //     const shouldRequest = window.confirm('We would like to send you notifications for important updates. Do you want to allow notifications?');
        //     if (shouldRequest) {
        //         const permissionStatus = await Notification.requestPermission();
        //         if (permissionStatus !== 'granted') {
        //             alert('Notification permission was not granted.');
        //             return;
        //         }
        //     } else {
        //         alert('User declined to allow notifications.');
        //         return;
        //     }
        // }
        const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_VAPID_KEY,
        });
        if (token) {
            return token;
        }
    } catch (error) {
        console.error('Error while retrieving token: ', error);
    }
}
export default requestForToken;